var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEnhance(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)",
    stroke: "#75B4FF",
    strokeWidth: 1.286,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m15.81 18.852-2.058 5.583a.856.856 0 0 1-1.607 0l-2.057-5.583a.867.867 0 0 0-.515-.514l-5.582-2.057a.857.857 0 0 1 0-1.607l5.582-2.058a.867.867 0 0 0 .515-.514l2.057-5.582a.858.858 0 0 1 1.607 0l2.057 5.582a.867.867 0 0 0 .515.514l5.582 2.058a.857.857 0 0 1 0 1.607l-5.582 2.057a.868.868 0 0 0-.515.514v0ZM19.806 1.763v5.143M22.378 4.334h-5.143M24.95 7.763v3.428M26.664 9.477h-3.43"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(.948 .048)",
    d: "M0 0h27.43v27.43H0z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnhance);
export default __webpack_public_path__ + "static/media/Enhance.fa1623043c11f85bbbcf346c6c2c29f4.svg";
export { ForwardRef as ReactComponent };